/*
 * Date: 2023
 * Description: Invoicing
 * Author: Philippe Leroux @ skitsc
 */

import { Box } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_initial_props } from "../interfaces/utility.interface"

const Invoicing = ( props : i_initial_props ) : ReactElement => {
    return (
        <Box>

        </Box>
    )
}


export default Invoicing